import React, { useEffect, useRef, useState } from 'react';
import useFetchData from '../hooks/useFetchData';
import BackButton from './Buttons/BackButton';
import Loader from './Loader';
import Struct from './Struct';
import { Menu } from './Menu';

import { useLocation } from 'react-router-dom';


const BasePage = ({ url, content, noAjax = false, title, hide_footer = false }) => {
    const data = useFetchData(url);
    const [isSticky, setIsSticky] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 100) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
    };

    const [isOpen, setIsOpen] = useState(false);

    const location = useLocation();
    // Détermine si on est sur la page d'accueil
    const isHomePage = location.pathname === '/dashboard';

    const openMenu = () => {
        setIsOpen(!isOpen)
    }

    const closeMenu = () => {
        setIsOpen(false);
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

     useEffect(() => {
        const handleClickOutside = (event) => {
            // if (menuNav.current && !menuNav.current.contains(event.target)) {
            //     console.log('click outsite')
            //     closeMenu();
            // }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    // console.log(url);
    return (
        <>
           <Struct hide_menu={!data}>
            {data ? (
                <>
                {/* Bouton menu fixe en haut */}
                <button
                    className={`m-2 z-[1001] ${isHomePage ? 'text-black' : 'text-white'}`}
                    onClick={openMenu}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu">
                    <line x1="4" x2="20" y1="12" y2="12" />
                    <line x1="4" x2="20" y1="6" y2="6" />
                    <line x1="4" x2="20" y1="18" y2="18" />
                    </svg>
                </button>

                {/* Header interne */}
                <div className={`header-interne flex justify-between items-center bg-[rgb(140_200_60/var(--tw-bg-opacity,1))] p-4 ${isSticky ? 'sticky-title' : ''}`}>
                    <BackButton />
                    {title && (
                        <h1>{title}</h1>
                    )}
                    <button
                    className="m-2 z-[1001] text-white"
                    onClick={openMenu}
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu">
                        <line x1="4" x2="20" y1="12" y2="12" />
                        <line x1="4" x2="20" y1="6" y2="6" />
                        <line x1="4" x2="20" y1="18" y2="18" />
                    </svg>
                    </button>
                </div>

                {/* Contenu de la page */}
                <div className="pt-6 pb-8">
                    {content(data)}
                </div>

                {/* Menu latéral contrôlé par BasePage */}
                <Menu isOpen={isOpen} openMenu={openMenu} closeMenu={closeMenu} />
                </>
            ) : (
                <div className="loader flex flex-col items-center justify-center w-full h-full fixed left-0 top-0">
                <p className="text-lg">Chargement en cours...</p>
                <div role="status" className="mt-4">
                    <Loader firstColor="mlime" />
                </div>
                </div>
            )}
            </Struct>
        </>
    );
};

export default BasePage;
